"use strict";

// Generated by scripts/write-version.cjs from package.json. Do not edit.
export const BRIDGE_VERSION = "0.0.8";
//# sourceMappingURL=version.js.map